<template>
  <div class="weui-btn" :class="[{'weui-btn_disabled':disabled},`weui-btn_${btnType}`]" :disabled="disabled">
    <slot></slot>
  </div>
</template>
<style lang="scss" scoped>
  @import "./index";
</style>
<script>
  export default {
    name: 'c-button',
    props: {
      btnType: {
        /**
         * @type [primary,default]
         */
        type: String,
        default: 'primary'
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {}
    },
    components: {},
    created () {
    },
    mounted () {
    },
    beforeDestroy () {
    },
    methods: {},
    computed: {},
    events: {}
  }
</script>



// WEBPACK FOOTER //
// index.vue?cacd8ea6